import { EntityId } from "@reduxjs/toolkit";
import axios from "axios";

export interface ProjectTag {
  id: EntityId;
  name: string;
  color?: string;
}

export interface ProjectImage {
  id: EntityId;
  src: string;
  name: string;
}

export interface Project {
  id: EntityId;
  name: string;
  briefDescription?: string;
  fullDescription: string;
  githubRepo?: string;
  liveSite?: string;
  show: boolean;
}

export interface ProjectTagRelation {
  id: EntityId;
  projectID: EntityId;
  tagID: EntityId;
}

export interface ProjectImageRelation {
  id: EntityId;
  projectID: EntityId;
  imageID: EntityId;
}

export const projects: Project[] = [
  {
    id: 1,
    name: "Muugenn",
    fullDescription: "Full Description",
    briefDescription: "Browse images infinitely. Powered by Unsplash.",
    githubRepo: "https://github.com/cs-clarence/muugenn",
    liveSite: "https://muugenn.netlify.app/",
    show: true,
  },
  {
    id: 2,
    name: "Jottio",
    fullDescription: "Full Description",
    briefDescription: "Take notes and format them using Markdown.",
    githubRepo: "https://github.com/cs-clarence/jottio-frontend",
    liveSite: "https://jottio.netlify.app/",
    show: false,
  },
];

export const tags: ProjectTag[] = [
  { id: 1, name: "ReactJS", color: "#90FFF8" },
];
export const tagRelations: ProjectTagRelation[] = [
  { id: 1, projectID: 1, tagID: 1 },
  { id: 2, projectID: 2, tagID: 1 },
];

export const images: ProjectImage[] = [
  {
    id: 1,
    src: "https://i.ibb.co/2n5cDLb/1.png",
    name: "unsplash",
  },
  {
    id: 2,
    src: "https://i.ibb.co/QCCT4BC/2.png",
    name: "unsplash",
  },
  {
    id: 3,
    src: "https://i.ibb.co/2ZmLRh6/3.png",
    name: "unsplash",
  },
  {
    id: 4,
    src: "https://i.ibb.co/sQkQmhC/4.png",
    name: "unsplash",
  },
];
export const imageRelations: ProjectImageRelation[] = [
  { id: 1, projectID: 1, imageID: 1 },
  { id: 2, projectID: 1, imageID: 2 },
  { id: 3, projectID: 1, imageID: 3 },
  { id: 4, projectID: 1, imageID: 4 },
];

export interface ProjectsData {
  projects: Project[];
  tags: ProjectTag[];
  tagRelations: ProjectTagRelation[];
  images: ProjectImage[];
  imageRelations: ProjectImageRelation[];
}

export const projectsAPI = {
  async fetchData() {
    const data = {
      projects: (
        await axios.get<Project[]>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/projects`
        )
      ).data,
      tags: (
        await axios.get<ProjectTag[]>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/projects/tags`
        )
      ).data,
      tagRelations: (
        await axios.get<ProjectTagRelation[]>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/projects/tag-relations`
        )
      ).data,
      images: (
        await axios.get<ProjectImage[]>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/projects/images`
        )
      ).data,
      imageRelations: (
        await axios.get<ProjectImageRelation[]>(
          `${process.env.REACT_APP_BACKEND_URL ?? ""}/projects/image-relations`
        )
      ).data,
    };
    return data;
  },
};
